import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_9rhufegspe_thi_c83dec056f: FaireThemeEntity = {
  token: "board_demo_r_9rhufegspe_thi_c83dec056f",
  type: "theme",
  retailerToken: "r_9rhufegspe",
  name: "Downtown Jersey City Farmers Market Essentials",
  description:
    "Small, high-turnover accessories and charms designed to maximize your footprint and appeal to local shoppers at the Downtown Jersey City Farmers Market.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/d3deed65d013d14186f1aff91e0743b866dbe527d4d242b2c6844627dd783699.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/d3deed65d013d14186f1aff91e0743b866dbe527d4d242b2c6844627dd783699.jpeg",
    "https://cdn.faire.com/fastly/0906fab7e96152e1eff6065bbf1980d17ae1c62c802a668f313bf39be7f582e9.jpeg",
    "https://cdn.faire.com/fastly/06b812a4e6e0da424cab08459720045f8868d699f7d778ef27fec02a214d694a.jpeg",
    "https://cdn.faire.com/fastly/60563fc19877a979b09ad7155991cded1fe0b86829a30d8c1a7a45109a035659.jpeg",
    "https://cdn.faire.com/fastly/293e4efb8844e77c490d6b1d1f3bdb4edbe6ced34d776ba5faf4651fe8c16cc0.png",
    "https://cdn.faire.com/fastly/62835e6f8575a47595f57702b7ae8aed3740c119271a455fd99ed98fca02839d.jpeg",
  ],
  itemCount: 65,
  source: "eric_themes_ideas",
  teaser: "thi_c83dec056f",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
